/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const share_ios = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.4 5.667h.933a.933.933 0 0 1 .934.933v7.467a.933.933 0 0 1-.934.933h-8.4A.933.933 0 0 1 3 14.067V6.6a.933.933 0 0 1 .933-.933h.934M8.133 1v6.533m2.334-4.2L8.133 1 5.8 3.333"
    />
  </svg>
)
export default share_ios
